<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */
 -->

<template>
  <div class="orangehrm-top-padding">
    <oxd-text tag="h6" class="orangehrm-main-title">
      {{ $t('admin.add_job_title') }}
    </oxd-text>
    <oxd-divider />
    <oxd-form :loading="isLoading" @submitValid="onSave">
      <oxd-form-row>
        <oxd-grid :cols="2" class="orangehrm-full-width-grid">
          <oxd-grid-item>
            <oxd-input-field
              v-model="jobAssign.jobId"
              type="select"
              :label="$t('general.job_title')"
              :options="normalizedJobTitles"
              :disabled="isEmployee"
            />
          </oxd-grid-item>
          <oxd-grid-item>
            <div>
              <file-input
                v-model="file"
                placeholder="Select file"
                :has-error="showRequiredFiles"
                :is-single="true"
                :required="true"
              />
              <span
                v-if="showRequiredFiles"
                class="oxd-text oxd-text--span oxd-input-field-error-message oxd-input-group__message"
              >
                Required
              </span>
            </div>
          </oxd-grid-item>
        </oxd-grid>
      </oxd-form-row>
      <oxd-form-row>
        <oxd-grid :cols="2" class="orangehrm-full-width-grid">
          <oxd-grid-item>
            <date-input
              v-model="jobAssign.startDate"
              :label="$t('general.start_date')"
              :disabled="isEmployee"
              :required="true"
            />
          </oxd-grid-item>

          <oxd-grid-item>
            <date-input
              v-model="jobAssign.endDate"
              :label="$t('general.end_date')"
              :disabled="isEmployee"
            />
          </oxd-grid-item>
        </oxd-grid>
      </oxd-form-row>

      <oxd-form-actions>
        <oxd-button
          type="button"
          display-type="ghost"
          label="Cancel"
          @click="onCancel"
        />
        <submit-button :disabled="isDisabled" />
      </oxd-form-actions>
    </oxd-form>
    <oxd-divider />
  </div>
</template>

<script>
// import FileUploadInput from '@/core/components/inputs/FileUploadInput';
import {
  required,
  validSelection,
  maxFileSize,
  validFileTypes,
  validDateFormat,
  endDateShouldBeAfterStartDate,
} from '@ohrm/core/util/validation/rules';
import fileInput from '../FileInput';

const jobAssignModel = {
  jobId: null,
  startDate: '',
  endDate: '',
};

export default {
  name: 'SaveEmployeeJobAssign',

  components: {
    'file-input': fileInput,
  },
  props: {
    http: {
      type: Object,
      required: true,
    },
    empNumber: {
      type: String,
      required: true,
    },
    jobTitles: {
      type: Object,
      required: true,
    },
  },

  emits: ['close'],

  data() {
    return {
      isLoading: false,
      jobAssign: {...jobAssignModel},
      file: null,
      showRequiredFiles: false,
    };
  },

  computed: {
    isDisabled() {
      if (this.jobAssign.jobId == null) return true;

      if (this.jobAssign.startDate == null) return true;

      if (this.file == null) return true;

      return false;
    },
    normalizedJobTitles() {
      return this.jobTitles.map(jobTitle => {
        return {
          id: jobTitle.id,
          label: jobTitle?.deleted
            ? jobTitle.label + this.$t('general.deleted')
            : jobTitle.label,
        };
      });
    },
  },

  methods: {
    onSave() {
      this.isLoading = true;

      this.showRequiredFiles = false;
      if (this.file === null) {
        this.showRequiredFiles = true;
        this.isLoading = false;
        return;
      }

      const formData = new FormData();
      formData.append('jobId', this.jobAssign.jobId.id);
      formData.append('file', this.file);
      formData.append('startDate', this.jobAssign.startDate);
      formData.append('endDate', this.jobAssign.endDate);

      this.http
        .request({
          method: 'POST',
          url: `api/v2/pim/employees/${this.empNumber}/jobAssigns`,
          data: formData,
        })
        .then(response => {
          this.$emit('close', true);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onCancel() {
      this.$emit('close', true);
    },
    setFile() {
      this.file = this.$refs.fileInput.files[0];
    },
  },
};
</script>
